module.exports = __webpack_public_path__ + "static/media/brand-refresh-caret-up.2f1971d1.svg";